module.exports = {"title":"Register","body":"Early registers get discounts!","small":"We never share your information or use it to spam you."}